module.exports = __webpack_public_path__ + "img/pro_banner.91b0c3d3.jpg";